<template>
	<div id="subscriptions" class="subscriptions">
        <nav class="navbar navbar-light bg-light">
			<div class="form-inline">
                <select v-model="subscriptionId" class="form-control form-control-sm mr-sm-1" @change="getAllOrdersBySubscriptionLocal(1)">
                    <option value="0">Todos</option>
                    <option v-for="(item, index) in listSubscriptions" :key="index">{{ item.id }}</option>
                </select>
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromOrders" @change="getAllOrdersBySubscriptionLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToOrders" @change="getAllOrdersBySubscriptionLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchOrders"
					v-model="searchOrders"
					v-on:keyup.enter="getAllOrdersBySubscriptionLocal(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllOrdersBySubscriptionLocal(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
				<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nueva Suscripcion" @click="showSubscriptionModalComponentLocal(0)">
					<i class="fas fa-plus"></i>
				</button>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsOrder" @change="changeQRowsOrder">
					<option>5</option>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
				<div class="float-right d-none d-sm-inline separator"></div>
				<router-link :to="'statistic/subscription/' + subscriptionId" class="far fa-chart-bar pointer text-info margin-right5" title="Estadisticas"></router-link>
				<router-link :to="'subscriptionGenerate/' + subscriptionId" class="fas fa-ticket-alt pointer text-info margin-right5" title="Generar Envios de Susrcipción"></router-link>
				<router-link :to="'subscriptionInvoices/' + subscriptionId" class="fas fa-file-invoice pointer text-info" title="Documentos Electronicos"></router-link>
			</div>
		</nav>

		<table class="table table-sm table-hover">
			<thead>
				<tr>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('orders.id')">ID</span></th>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('orders.subscription_id')">Año</span></th>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('entities.synthetic')">Campo</span></th>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('churchs.name')">Iglesia</span></th>
					<th class="text-center"><span>Coordinador</span></th>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('clients.name')">Cliente</span></th>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('orders.created_at')">Fecha</span></th>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('orders.status_id')">Estado</span></th>
					<th class="text-center"><span class="pointer" @click="setOrderByOrder('orders.total')">Total</span></th>
					<th class="text-center" @contextmenu="showMenuPaid" @blur="viewMenu == false">
						<span @click="setOrderByOrder('orders.paid')">Pagado</span>
					</th>
					<th class="text-center">Facturado</th>
					<th class="text-center">Migrado</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listOrders" :key="index">
					<td class="text-center" @click="showConsole(item)">{{ item.id }}</td>
					<td class="text-center">{{ item.subscription_id }}</td>
					<td class="text-center">{{ item.synthetic }}</td>
					<td class="text-center" :title="item.church_id">{{ item.type_church }} {{ item.church.name }}</td>
					<td class="text-center">
						<span v-if="item.church.client != null" :title="item.church.client.client_id">{{item.church.client.name}} {{item.church.client.surname}}</span>
						<i class="fas fa-minus text-black-50" v-else></i>
					</td>
					<td class="text-center" :title="item.client_id">{{ item.client.name }} {{ item.client.surname }}</td>
					<td class="text-center">{{ item.created_at }}</td>
					<td class="text-center" :title="item.status_id">{{ item.status }}</td>
					<td class="text-right">{{ methodFormatNumber(item.total) }}</td>
					<td class="text-center">
						<i class="fas fa-check text-success" v-if="item.paid == 1"></i>
						<i class="fas fa-minus text-black-50" v-else></i>
					</td>
					<td class="text-center">
						<i class="fas fa-check text-success" v-if="item.legal_documents.length > 0"></i>
						<i class="fas fa-minus text-black-50" v-else></i>
					</td>
					<td class="text-center">
						<i class="fas fa-check text-success" v-if="item.genesys != null" :title="'Comprobante de genesys ' + item.genesys.nrocomp"></i>
						<i class="fas fa-minus text-black-50" v-else></i>
					</td>
					<td class="text-right">
						<i class="fas fa-exclamation-triangle text-warning margin-right5" v-show="analizePaymentsRejectedLocal(item.payments) > 0" :title="'Tiene ' + analizePaymentsRejectedLocal(item.payments) + ' pago(s) rechazado(s)'"></i>
						<i class="pointer far fa-file-alt margin-right5" @click="showUploadDocumentModalComponentLocal(item.id)" :class="(item.upload_documents.length > 0) ? 'text-primary' : 'text-black-50'" :title="'Ver documentos Adjuntos (' + item.upload_documents.length + ')'"></i>
						<i class="pointer far fa-credit-card margin-right5" @click="showPaymentModalComponentLocal(item)" :class="(item.payments.length > 0) ? analyzePayment(item) : 'text-black-50'" :title="'Ver Forma de pago (' + item.payments.length + ')' "></i>
						<router-link :to="'/subscription/' + item.id" :target="'_blank ' + item.id" class="pointer far fa-eye text-info" title="Ver detalle"></router-link>
					</td>
				</tr>
			</tbody>
		</table>
		
        <pagination :pagination="paginationOrders" @getAllList="getAllOrdersBySubscriptionLocal"></pagination>

		<upload-document-modal-component ref="uploadDocumentModalComponent" controller="order" configUploadDocumentId="1" :id="id" :btnDelete="true" :btnUpload="true"></upload-document-modal-component>
		
		<payment-modal-component ref="paymentModalComponent" controller="order" :id="id" title="Suscripción" :modal="true" :totalToPaid="totalToPaid"></payment-modal-component>

		<subscription-modal-component ref="subscriptionModalComponent" :subscriptionId="itemSelectedListSubscription.id" :defaultPriceListId="itemSelectedListSubscription.price_list_id" :id="id" :url="apiBackend" @actionSaveSubscription="addListOrders"></subscription-modal-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import order from '@/mixins/orders'
import subscription from '@/mixins/generals/subscription.js'
import payment from '@/mixins/generals/payment.js'

import Pagination from '@/components/Pagination.vue'
import SubscriptionModalComponent from '@/components/SubscriptionModalComponent.vue'
import UploadDocumentModalComponent from '@/components/UploadDocumentModalComponent.vue'
import PaymentModalComponent from '@/components/PaymentModalComponent.vue'

export default {
	name: 'Subscriptions',
	mixins: [axiosAction, errors, mixin, order, subscription, payment],
	data() {
		return {
			id: 0,
			totalToPaid: 0,
			viewMenu: false
		}
	},
	computed: {
		itemSelectedListSubscription() {
			let list = {subscription_id: 0, price_list_id: 0}
			let index = this.listSubscriptions.map(s => parseInt(s.id)).indexOf(parseInt(this.subscriptionId))
			if(index > -1)
				list = this.listSubscriptions[index]
			return list
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Suscripciones')
			this.setSubTitleModule('')
			this.setOrderInit()
			this.loadInfoInit()
			this.setListeningOrder()
		},
		analyzePayment(item) {
			if(item.paid == 1)
				return 'text-success'
			
			return 'text-info'
		},
		changeQRowsOrderLocal() {
			this.getAllOrdersBySubscriptionLocal(1)
		},
		getAllOrdersResultLocal(response) {
			document.title = 'Suscripciones - ' + this.subscriptionId
		},
		getAllOrdersBySubscriptionLocal(page = 1) {
			this.getAllOrdersBySubscription(page)
		},
		getAllSubscriptionsResultLocal(response) {
			if(this.listSubscriptions.length > 0) {
				this.listSubscriptions.forEach((el) => {
					if(el.active == '1') {
						this.subscriptionId = el.id
					}
				})
				this.subscriptionId = (this.subscriptionId == 0) ? this.listSubscriptions[this.listSubscriptions.length - 1].id : this.subscriptionId
			}
			this.getAllOrdersBySubscriptionLocal(1)
		},
		loadInfoInit() {
			this.getAllSubscriptions()
			this.loadInfoInitEnd()
		},
		loadInfoInitEnd() {
			//this.getAllOrdersBySubscriptionLocal()
		},
		setOrderInitLocal() {
			this.setListeningOrder()
			this.searchQuery.push({column: 'paid', numeric: true, default: -1}, {column: 'status', numeric: true, default: -1})
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'addOrderTrackingsOrderResult': this.addOrderTrackingsOrderResult(response); break;
				case 'getAllOrdersResult': this.getAllOrdersResult(response); break;
				case 'getAllSubscriptionsResult': this.getAllSubscriptionsResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		showMenuPaid(event) {
			this.viewMenu = true
			console.log(event)
			event.preventDefault()
		},
		closeMenu() {
			this.viewMenu = false
		},
		showPaymentModalComponentLocal(item) {
			this.id = item.id
			this.totalToPaid = item.total
			setTimeout(() => {
				this.$refs.paymentModalComponent.$refs.showPayment.click()
				this.$refs.paymentModalComponent.$refs.btnGetPayment.click()
			}, 10)
		},
		showSubscriptionModalComponentLocal(id) {
			this.id = id
			this.$refs.subscriptionModalComponent.$refs.newSusbcription.click()
			setTimeout(() => {
				this.$refs.subscriptionModalComponent.$refs.getSusbcription.click()
			}, 10)
		},
		showUploadDocumentModalComponentLocal(id) {
			this.id = id
			setTimeout(() => {
				this.$refs.uploadDocumentModalComponent.$refs.btnGetUploadDocument.click()
				this.$refs.uploadDocumentModalComponent.$refs.showUploadDocument.click()
			}, 10)
		}
	},
	components: {
		'pagination': Pagination,
		'subscription-modal-component': SubscriptionModalComponent,
		'upload-document-modal-component': UploadDocumentModalComponent,
		'payment-modal-component': PaymentModalComponent,
	},
	mounted () {
		this.initModule()
	}
}
</script>

<style scoped lang="scss">
</style>